import React, { Fragment } from 'react';
import { Reveal, Tween } from 'react-gsap';

interface FadeFromLeftProps {
	children: any;
}
export const FadeInLeft = ({ children }: FadeFromLeftProps) => {
	return (
		<Fragment>
			<Tween from={{ opacity: -1, transform: 'translate3d(-100vw, 0, 0)' , duration: 1 }} ease="back.out(0.4)" >
				{children}
			</Tween>
		</Fragment>
	);
};

export const FadeIn = ({ children }: FadeFromLeftProps) => {
	return (
		<Fragment>
			<Tween from={{ opacity: 0 }} ease="back.out(1.2)" to={{ opacity: 1, autoAlpha: 1, duration: 8 }}>
				{children}
			</Tween>
		</Fragment>
	);
};

export const BounceOut = ({ children }: FadeFromLeftProps) => {
	return (
		<Fragment>
			<Tween from={{ opacity: -1, transform: 'scale(2)', duration: 1 }} ease="back.out(0.4)">
				{children}
			</Tween>
		</Fragment>
	);
};
